import { InView } from "./constants/enum.pos";

export class OpenMenuMobile {
	inview: InView = null;
	isOpen: boolean = false;
}
export class OpenCategoryMobile {
	inview: InView = null;
	isOpen: boolean = false;
}

export class OpenActionTicketMobile {
	inview: InView = null;
	isOpen: boolean = false;
}
